var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-inline-container" }, [
    _c("div", { ref: "modal" }, [
      _c(
        "div",
        { class: "modal" + (_vm.cssClass ? " modal--" + _vm.cssClass : "") },
        [
          _vm.$slots.alert
            ? _c("div", { staticClass: "modal__alert" }, [_vm._t("alert")], 2)
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.header
            ? _c("div", { staticClass: "modal__header" }, [_vm._t("header")], 2)
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "modal__body" }, [_vm._t("body")], 2),
          _vm._v(" "),
          _vm.$slots.footer
            ? _c("div", { staticClass: "modal__footer" }, [_vm._t("footer")], 2)
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }